import { message } from 'antd';
import getAttachmentType from './getAttachmentType';
import { maxFileSize } from '../constants/maxFileSize';

const validateFile = (
  file = {},
  config = {
    onlyPicture: false,
  }
) => {
  if (file.size > 15728640) {
    message.error('Файл должен весить не больше 15 мб');
    return false;
  }
  if (config.onlyPicture && getAttachmentType(file.name) !== 'picture') {
    message.error('Допустимые расширения изображений: jpg, jpeg, png, gif');
    return false;
  }
  return true;
};

export const validateFileSizeForForm = (_, value, callback) => {
  if (Boolean(value?.length)) {
    const bigFiles = value.filter((file) => file.size > maxFileSize);

    if (Boolean(bigFiles.length)) {
      callback(`Выделенные файлы весят больше 15 Мб`);
    } else {
      callback();
    }
  } else {
    callback();
  }
};

export default validateFile;
